import React from "react";
import { Link } from "react-router-dom";
import projMan from '../../images/projSub.jpg'
import studentReq from '../../images/studentReq.jpg'
import sece from '../../images/sece.jpg';
import adminAssist from '../../images/adminAssist.jpg';
import DigitalMarketer from '../../images/digitalMarketer2.jpg';
import AdmissionOfficer from '../../images/digitalMarketer2.jpg';
import GM from '../../images/digitalMarketer3.jpg';

const ClickHandler = () => {
    window.scrollTo(10, 0);
}

const CareerSection = () => {
    // Job listings data structure
    const jobListings = [
        // Row 1
        {
            id: 0,
            title: "Admissions Officer",
            date: "19",
            month: "June",
            year: "2026",
            image: DigitalMarketer,
            link: "/career/Admissions-Officer",
            alt: "Admissions Officer position"
        },
        {
            id: 1,
            title: "Digital Marketing Specialist Lagos",
            date: "15",
            month: "May",
            year: "2026",
            image: DigitalMarketer,
            link: "/career/Digital-Marketing-Specialist-Lagos",
            alt: "Digital Marketing Specialist Lagos"
        },
        {
            id: 2,
            title: "Digital Marketing Specialist Abuja",
            date: "15",
            month: "May",
            year: "2026",
            image: DigitalMarketer,
            link: "/career/Digital-Marketing-Specialist-Abuja",
            alt: "Digital Marketing Specialist Abuja"
        },
        {
            id: 3,
            title: "Secretary (Administrative Assistant)",
            date: "3",
            month: "March",
            year: "2026",
            image: adminAssist,
            link: "/career/Administrative-Assistant",
            alt: "Administrative Assistant position"
        },
        {
            id: 4,
            title: "Digital Marketing Specialist",
            date: "16",
            month: "January",
            year: "2026",
            image: DigitalMarketer,
            link: "/career/Digital-Marketer",
            alt: "Digital Marketing Specialist position"
        },
        {
            id: 5,
            title: "Students Recruitment Counsellor",
            date: "16",
            month: "January",
            year: "2026",
            image: studentReq,
            link: "/career/Counsellor4",
            alt: "Student Recruitment Counsellor position"
        },
        // Row 2
        {
            id: 6,
            title: "General Manager",
            date: "18",
            month: "November",
            year: "2025",
            image: GM,
            link: "/career/General-Manager",
            alt: "General Manager position"
        },
        {
            id: 7,
            title: "Students Recruitment Counsellor",
            date: "30",
            month: "October",
            year: "2025",
            image: studentReq,
            link: "/career/Counsellor3",
            alt: "Student Recruitment Counsellor position"
        },
        {
            id: 8,
            title: "Students Recruitment Counsellor",
            date: "30",
            month: "October",
            year: "2025",
            image: studentReq,
            link: "/career/Counsellor2",
            alt: "Student Recruitment Counsellor position"
        },
        // Row 3
        {
            id: 9,
            title: "Students Recruitment Counsellor",
            date: "28",
            month: "April",
            year: "2025",
            image: studentReq,
            link: "/career/Counsellor",
            alt: "Student Recruitment Counsellor position"
        },
        {
            id: 10,
            title: "Secretary (Admissions & Customer Support)",
            date: "14",
            month: "Mar",
            year: "2025",
            image: sece,
            link: "/career/Secretary",
            alt: "Secretary position"
        },
        {
            id: 11,
            title: "Construction Project Manager - Asaba",
            date: "24",
            month: "Jan",
            year: "2025",
            image: projMan,
            link: "/career/Project-Management",
            alt: "Construction Project Manager position"
        },
        {
            id: 12,
            title: "International Student Recruitment Officer (Admissions Officer)",
            date: "28",
            month: "Jan",
            year: "2025",
            image: studentReq,
            link: "/career/Student-Recruitment",
            alt: "International Student Recruitment Officer position"
        }
    ];

    // Group jobs into rows of 3
    const groupJobsIntoRows = (jobs, itemsPerRow = 3) => {
        const rows = [];
        for (let i = 0; i < jobs.length; i += itemsPerRow) {
            rows.push(jobs.slice(i, i + itemsPerRow));
        }
        return rows;
    };

    const jobRows = groupJobsIntoRows(jobListings);

    return (
        <section className="blog-section section-padding pt-5">
            <div className="container">
                <div className="row">
                    <div className="col col-lg-6 col-12">
                        <div className="section-title-s2">
                            <span>Employment</span>
                            <h2>Employment Opportunities</h2>
                        </div>
                    </div>
                </div>

                {jobRows.map((row, rowIndex) => (
                    <div className="row" key={`row-${rowIndex}`}>
                        <div className="col col-xs-12">
                            <div className="blog-grids clearfix">
                                {row.map((job) => (
                                    <article className="grid" key={job.id}>
                                        <div className="entry-media">
                                            <img 
                                                src={job.image} 
                                                alt={job.alt}
                                                loading="lazy" // Lazy loading for better performance
                                            />
                                        </div>
                                        <div className="entry-date">
                                            <h4>{job.date}</h4>
                                            <span>{job.month}<br />{job.year}</span>
                                        </div>
                                        <h3>
                                            <Link 
                                                to={job.link} 
                                                onClick={ClickHandler}
                                                title={job.title}
                                            >
                                                {job.title}
                                            </Link>
                                        </h3>
                                    </article>
                                ))}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
}

export default CareerSection;